var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L15.3039 1.62309C15.7107 1.71348 16 2.0742 16 2.49082V11.3679C16 13.1511 15.1088 14.8164 13.6251 15.8055L8 19.5556L2.37493 15.8055C0.891209 14.8164 0 13.1511 0 11.3679V2.49082C0 2.0742 0.28936 1.71348 0.696062 1.62309L8 0ZM8 1.82115L1.77778 3.20386V11.3679C1.77778 12.5567 2.37191 13.6668 3.36107 14.3263L8 17.4189L12.6389 14.3263C13.6281 13.6668 14.2222 12.5567 14.2222 11.3679V3.20386L8 1.82115ZM11.9577 6.41941L13.2148 7.67648L7.55787 13.3333L3.78666 9.56213L5.04374 8.30498L7.55724 10.8186L11.9577 6.41941Z",
    fill: "#7E8392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.618156ae841c7f3a791acf79422a5bfe.svg";
export { ForwardRef as ReactComponent };